// extracted by mini-css-extract-plugin
module.exports = {"root":"CtuxbKHx","icon":"oXXcD2zq","message":"_3a09+Q1q"};